import React from 'react';
import DatePicker from 'apollo-react/components/DatePicker';
import moment from 'moment';

const DateInput = ({
  field,
  meta,
  label,
  onChange,
  required,
  value,
  fullWidth = true,
}) => {
  return (
    <DatePicker
      {...field}
      label={label}
      defaultValue={moment()}
      placeholder="mm/dd/yyyy"
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error ? meta.error : 'Select a date'}
      onChange={(value) => onChange(value)}
      value={value}
      required={required}
      fullWidth={fullWidth}
    />
  );
};

export default DateInput;
